import React, { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ClearIcon from "@mui/icons-material/Clear";
import CustomMenu from "../../../../components/Menu";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import FilterListIcon from '@mui/icons-material/FilterList';

function EstimatedFilter() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [estimated, setEstimated] = useCustomSearchParams('estimated');
  
  const handleChange = (e) => {
    if (e === estimated){
      setEstimated("estimated","All");
    }else setEstimated("estimated", e);

    console.log(estimated);
  };

  const handleClearFilter = (e) => {
    e.stopPropagation();
    handleChange('All');
    setAnchorEl(null);
  };

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const hasActiveFilter = estimated && estimated !== "All";
  const filterCount = hasActiveFilter ? 1 : 0;
  const isMenuOpen = !!anchorEl;

  return (
    <>
      <div className="estimated-filter-wrapper">
        <button
          className={`estimated-filter-button ${isMenuOpen ? 'active' : ''}`}
          onClick={handleToggleMenu}
        >
          <FilterListIcon className="filter-icon" />
          <span className="filter-text">Filter</span>
          {hasActiveFilter && (
            <>
              <span className="filter-count">{filterCount}</span>
              <ClearIcon
                className="filter-clear-icon"
                onClick={handleClearFilter}
              />
            </>
          )}
          {isMenuOpen ? (
            <KeyboardArrowUpIcon className="filter-chevron" />
          ) : (
            <KeyboardArrowDownIcon className="filter-chevron" />
          )}
        </button>
        {/* {isMenuOpen && <div className="filter-active-indicator" />} */}
      </div>
      <CustomMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        handleClose={() => setAnchorEl(null)}
      >
        <CustomMenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleChange('Watching');
          }}
        >
          <label className="custom-checkbox">
            <input
              type="checkbox"
              id={`board-estimated-filter-checkbox-watching`}
              checked={estimated === "Watching"}
              // onChange={() => handleChange('Watching')}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
            <span className="checkmark"></span>
            Watching
          </label>
        </CustomMenuItem>
        <CustomMenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleChange('Estimated');
          }}
        >
          <label className="custom-checkbox">
            <input
              type="checkbox"
              id={`board-estimated-filter-checkbox-estimated`}
              checked={estimated === "Estimated"}
              // onChange={() => handleChange('Estimated')}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
            <span className="checkmark"></span>
            Estimated
          </label>
        </CustomMenuItem>
        <CustomMenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleChange('Not Estimated');
          }}
        >
          <label className="custom-checkbox">
            <input
              type="checkbox"
              id={`board-estimated-filter-checkbox-not-estimated`}
              checked={estimated === "Not Estimated"}
              // onChange={() => handleChange('Not Estimated')}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
            <span className="checkmark"></span>
            Not Estimated
          </label>
        </CustomMenuItem>
      </CustomMenu>
    </>
  );
}

export default EstimatedFilter;
